import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../components/card/card.jsx";
import Degradation from "./charts/degradation";
import { useParams } from "react-router-dom";
import FinanceData from "./finance-data/maintenance";
import { useReactToPrint } from "react-to-print";
import { matar } from "../../../api";
function MachineList() {
  let { assetId, groupId } = useParams();
  const [group, setGroup] = useState(null);
  useEffect(() => {
    if (assetId) {
      setSelectedAsset(assetId);
    }
    if (groupId) {
      getOne();
    }
  }, [assetId, groupId]);
  const getOne = async () => {
    const res = await matar.getOneGroup({ id: groupId });
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      setGroup(data.MachineGroup);
      if (data.MachineGroup?.length) {
        setSelectedAsset(data.MachineGroup[0]?.machine_id);
      }
    }
  };
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [downloadCounter, setDownloadCounter] = useState(0);
  const componentRef = useRef();
  const downloadHandler = useReactToPrint({
    content: () => componentRef.current,
  });
  const downloadExcelHandler = () => {
    setDownloadCounter(downloadCounter + 1);
  };
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">MACHINE</a>
            </li>
            <li className="breadcrumb-item active">ASSET RUL</li>
          </ul>
          <div className={"d-flex justify-content-between"}>
            <h2 className="page-header">Asset Deterioration</h2>
            <div>
              <button
                className="btn btn-outline-theme btn-sm"
                onClick={downloadExcelHandler}
                style={{ marginRight: "4px" }}
              >
                <i className="fa fa-file-excel"></i> Download Excel
              </button>
              <button
                onClick={downloadHandler}
                className="btn btn-outline-theme btn-sm"
              >
                <i className="fa fa-file-pdf"></i> Download PDF
              </button>
            </div>
          </div>
          <Card
            className="bg-theme border-theme bg-opacity-25 mb-3"
            style={{ width: "250px" }}
          >
            {assetId ? (
              <CardHeader className="border-theme fw-bold small text-white text-center">
                Asset ID : <b>{selectedAsset}</b>
              </CardHeader>
            ) : (
              <CardHeader className="border-theme fw-bold small text-white text-center">
                <div className={"from-group my-2 w-100"}>
                  <label>Select Asset : </label>
                  {group ? (
                    <select
                      value={selectedAsset}
                      onChange={(e) => setSelectedAsset(e.target.value)}
                      className={"form-control border-theme text-theme"}
                    >
                      {group.map((item, index) => (
                        <option
                          key={index}
                          value={item.machine_id}
                          className={"text-theme"}
                        >
                          {item.machine_id}
                        </option>
                      ))}
                    </select>
                  ) : null}
                </div>
              </CardHeader>
            )}
          </Card>
          <hr className="mb-4" />
          <Card className="bg-blue-900 border-theme  mb-3">
            <CardBody>
              <div className="row" ref={componentRef}>
                <div className={"print-header"}>
                  <img
                    src="/img/hamad_header.png"
                    style={{ height: "80px" }}
                    alt=""
                  />
                </div>
                {selectedAsset ? (
                  <Degradation
                    assetId={selectedAsset}
                    download={downloadCounter}
                  />
                ) : null}
              </div>
            </CardBody>
          </Card>

          <hr className="mb-4" />
          {selectedAsset ? <FinanceData assetId={selectedAsset} /> : null}
        </div>
      </div>
    </div>
  );
}

export default MachineList;
